module.exports = __webpack_public_path__ + "img/organization.7ccafd58.svg";